// extracted by mini-css-extract-plugin
export default {"closeIcon":"modal_closeIcon__RJJ9p"};